import { apiUrl } from './client';

/**
 * Contact form request payload
 */
export interface ContactFormRequest {
  name: string;
  email: string;
  message: string;
}

/**
 * Contact form response from API
 */
export interface ContactFormResponse {
  success: boolean;
  message: string;
  errors?: { [key: string]: string[] };
}

/**
 * Submit contact form data to the backend API
 * @param formData The contact form data
 * @returns Promise resolving to the API response
 */
export async function submitContactForm(
  formData: ContactFormRequest
): Promise<ContactFormResponse> {
  try {
    const response = await fetch(apiUrl('/api/contact'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data: ContactFormResponse = await response.json();

    if (!response.ok) {
      // Return the error response from the API
      return data;
    }

    return data;
  } catch (error) {
    // Handle network errors
    console.error('Contact form submission error:', error);
    throw error;
  }
}
